
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myaccount/wishlist",
      function () {
        return require("private-next-pages/myaccount/wishlist.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myaccount/wishlist"])
      });
    }
  